/*
* FormsReducer
*/

import { fromJS } from 'immutable';
import { OFFER_SELECTED, DISPLAY_OFFERS } from './constants';

// The initial state of forms
export const initialState = fromJS({
  offer: {
    reference: null,
    distance: 0,
    duration: 0,
    deposit: 0,
    monthlyRate: 0,
  },
  display: false,
});

function offerSelectorReducer(state = initialState, action) {
  switch (action.type) {
    case OFFER_SELECTED:
      return state.set('offer', action.offer);
    case DISPLAY_OFFERS:
      return state.set('display', action.display);
    default:
      return state;
  }
}

export default offerSelectorReducer;
